import * as types from './Types.js';

export function findConfigAparencia(filtro) {
  return ({ fetch }) => ({
    type: types.CONFIG_APARENCIA,
    payload: fetch('/portalconfigaparencia?' + filtro)
  });
}
